import React, { Component, useEffect, Fragment } from "react";
import i18n from "../i18n";
import PopupModal from "./PopupModal";
import { translate } from "../Services/translation";
import {
    enable as enableBuyButton,
    disable as disableBuyButton,
    hide as hideBuyButton,
    show as showBuyButton
} from "../Actions/BuyButton.action";
import { connect } from "react-redux";
import FogsandCalculator from "./FogsandCalculator";
import QuantityCalculator from "./QuantityCalculator";

const SwedishCulture = "sv-SE";
const MaxQuantity = 9999;
const M2Unit = translate("priceCalculation.unitKey_M2"); //'m2'
const m2UnitV2 = translate("priceCalculation.unitKey_M2V2"); //'m²'
const stUnit = translate("priceCalculation.unitKey_St"); //'st';
const palletUnit = translate("priceCalculation.unitKey_pallet"); //'pallets';

class ProductQuantity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quantities: {
                [m2UnitV2]: props.unitDecimalDigits == 0 ? 0 : "0.00",
                [stUnit]: props.unitDecimalDigits == 0 ? 0 : "0.00",
                [palletUnit]: props.unitDecimalDigits == 0 ? 0 : "0.00",
            },
            quantity: props.unitDecimalDigits == 0 ? 0 : "0.00",
            total: parseFloat(0).toFixed(2),
            unitConversionText: translate("productpage.unitchangetext")
                .replace("{currentUnit}", `0,00 ${m2UnitV2}`)
                .replace("{changingUnit}", `0 ${stUnit}`),
            unit: "",
            palletInfo: this.props.palletInfo,
            quantityBeforeWastage: 0,
            isBusinessCustomer: __litium.isBusinessCustomer,
            isQuantityCalculatorOpen: false
        };
        this.subtract = this.subtract.bind(this);
        this.add = this.add.bind(this);
    }
    
    componentDidMount() {
        if (this.props.quantity && this.props.quantity > 1) {
            this.setQuantityState(this.props.quantity, this.props.unit);
            this.setQuantityBeforeWastage(this.props.quantity);
        } else if (this.props.wholePallet) {
            this.setQuantityState(this.props.quantityPerPallet, this.props.unit);
        } else if (this.props.quantity && this.props.quantity < 1) {
            this.setQuantityState(this.props.quantity, this.props.unit);
        } else {
            this.setQuantityState(1, this.props.unit);
        }
    }

    setQuantityState(value, unit) {
        let quantity = parseFloat(value);

        this.setState(
            (prevState) => ({
                quantities: {
                    ...prevState.quantities,
                    [unit]: quantity,
                },
            }),
            this.calculatePrice(unit, quantity)
        );

        if (unit === palletUnit) {
            quantity = this.setPalletDecimals(quantity)
        }

        const ref = this[`quantityInputElement_${unit}`];
        if (ref) {
            ref.value = this.asLocalizedNumber(quantity, this.shouldDisplayWithDecimals(unit), unit);
        }

        if (this.props.callbackParent) {
            const defaultUnit = this.getSelectedUnitValue();
            const defaultQuantity = this[`quantityInputElement_${defaultUnit}`].value;

            this.props.callbackParent(defaultQuantity);
        }
    
        this.triggerBuyButtonAvailability(quantity);
    }

    handleCalculation = (value) => {
        this.setQuantityState(value, this.getSelectedUnitValue())
    }

    triggerBuyButtonAvailability = (quantity) => {
        if (quantity > 0) {
            this.props.enableBuyButton();
        } else {
            this.props.disableBuyButton();
        }
    };

    setQuantityBeforeWastage = (value) => {
        this.setState({
            quantityBeforeWastage: value,
        });
    };

    getQuantityBeforeWastage = () => {
        return parseFloat(this.state.quantityBeforeWastage);
    };

    currentQuantity = (unit) => {
        const quantity = parseFloat(this.state.quantities[unit]);
        return quantity;
    };

    isWastageActive = () => {
        let checkBox = document.getElementById("chkWastage");
        return checkBox.checked;
    };

    setWastageIsActive = (value) => {
        let checkBox = document.getElementById("chkWastage");
        checkBox.checked = value;
    };

    subtract(unit) {
        const { quantityPerPallet, wholePallet } = this.props;
        const subtraction = wholePallet ? quantityPerPallet : 1;
        let newQuantity = 0;
        if (wholePallet) {
            if (unit === m2UnitV2) {
                newQuantity = parseFloat(this.state.quantities[unit]) - subtraction;
                if (newQuantity < quantityPerPallet) {
                    newQuantity = parseFloat(this.state.quantities[unit]);
                }
            }
            if (unit === palletUnit) {
                newQuantity = parseFloat(this.state.quantities[unit]) - 1;
            }
        } else {
            newQuantity = Math.ceil(parseFloat(this.state.quantities[unit]) - subtraction);
        }

        if (newQuantity > 0) {
            this.setQuantityState(newQuantity, unit);
            this.resetWastage();
            this.setQuantityBeforeWastage(newQuantity);
        }
    }

    add(unit) {
        const { quantityPerPallet, wholePallet } = this.props;
        const addition = wholePallet ? quantityPerPallet : 1;
        let newQuantity = 0;
        if (wholePallet) {
            if (unit === m2UnitV2) {
                newQuantity = parseFloat(this.state.quantities[unit]) + addition;
            }
            if (unit === palletUnit) {
                newQuantity = parseFloat(this.state.quantities[unit]) + 1;
            }
        } else {
            newQuantity = Math.floor(parseFloat(this.state.quantities[unit]) + addition);
        }

        this.setQuantityState(newQuantity, unit);
        this.resetWastage();
        this.setQuantityBeforeWastage(newQuantity);
    }

    getClosestAmountOfPallets(num, quantityPerPallet) {
        let closestAmountOfPallets =
            Math.ceil(num / quantityPerPallet) * quantityPerPallet;

        if (closestAmountOfPallets === 0)
            closestAmountOfPallets = quantityPerPallet;

        return closestAmountOfPallets;
    }

    resetQuantity = () => {
        this.setQuantityState(1);
    };

    updateModalButtonText = () => {
        const {
            isFromProductPage,
            quantityPerPallet,
            quantityPerSquareMeter,
            palletInfo,
        } = this.props;
        if (!isFromProductPage) return;
        this.state.palletInfo = {
            ...this.state.palletInfo,
            buttonText: palletInfo.buttonText,
            infoText: palletInfo.infoText
        };
    };

    resetWastage = () => {
        if (this.props.hasWastage) {
            this.setWastageIsActive(false);
        }
        this.setQuantityBeforeWastage(0);
    };

    onQuantityInputElementBlur = (event, unit) => {
        if (!unit) {
            unit = this.extractUnitFromElementId(event.target.id);
        }

        let normalizedInput = event.target.value
            .replace(",", ".")
            .replace(/[^\d,.]/, "") // Remove all characters except numericals or decimal separators.
            .trim();

        this.resetWastage();

        let quantity = normalizedInput;

        if (!this.shouldDisplayWithDecimals(unit)) {
            quantity = parseInt(quantity).toFixed(0);
        } else if (unit === palletUnit) {
            quantity = parseFloat(normalizedInput).toFixed(3);
        } else {
            quantity = parseFloat(normalizedInput).toFixed(2);
        }

        if (event.key === 'Enter') {
            let refName;
            if (unit === m2UnitV2) {
                refName = "quantityInputElement_m²";
            } else if (unit === stUnit) {
                refName = "quantityInputElement_st";
            } else if (unit === palletUnit) {
                refName = "quantityInputElement_pallets";
            }
        
            if (refName && this[refName]) {
                this[refName].blur();
            }
            return;
        }

        if (isNaN(quantity)) {
            if (unit === M2Unit || unit === m2UnitV2) {
                quantity = this.state.quantities[m2UnitV2];
            } else if (unit === stUnit) {
                quantity = this.state.quantities[stUnit];
            } else if (unit === palletUnit) {
                quantity = this.state.quantities[palletUnit];
            }
        }

        if ( quantity <= 0) {
            if (unit === M2Unit || unit === m2UnitV2) {
                quantity = 1.00;
            } else if (unit === stUnit) {
                quantity = 1;
            } else if (unit === palletUnit) {
                quantity = 1.0;
            }
        }

        if (quantity > MaxQuantity) quantity = MaxQuantity;

        if (
            this.props.wholePallet &&
            quantity % this.props.quantityPerPallet !== 0 &&
            unit !== palletUnit
        ) {
            quantity = this.getClosestAmountOfPallets(
                quantity,
                this.props.quantityPerPallet
            );
        }

        if (this.props.wholePallet && unit === palletUnit) {
            quantity = Math.ceil(quantity);
        }

        this.setQuantityState(quantity, unit);
    };

    isM2Unit = (unit) => {
        return unit === M2Unit || unit === m2UnitV2;
    };

    shouldDisplayWithDecimals = (unit) => {
        if (unit === stUnit) {
            return false;
        }
        return true;
    };

    getSelectedUnitValue = () => {
        return this.props.unit;
    };

    calculatePrice = (unit, quantity) => {
        switch (unit) {
            case M2Unit:
            case m2UnitV2:
                this.calculationsForM2(quantity);
                break;
            case palletUnit:
                this.calculationsForPallets(quantity);
                break;
            case stUnit:
            default:
                this.calculationsForSt(quantity);
                break;
        }
    };

    determinePrice = (price, campaignPrice) => {
        let priceF = parseFloat(price);
        let campaignPriceF = parseFloat(campaignPrice);
        return (campaignPriceF > 0 && campaignPriceF < priceF) ? campaignPriceF : priceF;
    }

    calculationsForM2 = (newQuantity) => {
        const { unit, price, priceExVat, priceCampaign, priceCampaignExVat, quantityPerPallet, quantityPerSquareMeter, unitList } = this.props;

        if (this.state.isBusinessCustomer){
            var currentPrice = this.determinePrice(priceExVat, priceCampaignExVat);
        } else {
            var currentPrice = this.determinePrice(price, priceCampaign);
        }
        let quantity = newQuantity;
        let hiddenQuantity = document.getElementById("calculatedquantity");
        let m2quantity = 0;
        if (this.isM2Unit(unit)) {
            m2quantity = parseFloat(quantity).toFixed(2);
        } else {
            m2quantity = this.roundUp(quantity * quantityPerSquareMeter);
        }
        let totalTemp = parseFloat(m2quantity * currentPrice).toFixed(2);
        hiddenQuantity.value = m2quantity;
        this.setState({ total: parseFloat(totalTemp).toFixed(2) });
        if (unitList) {
            this.setCorrespondingUnitState(
                quantity,
                m2UnitV2,
                unitList,
                quantityPerPallet,
                quantityPerSquareMeter,
                null
            );
        }
    };

    calculationsForSt(newQuantity) {
        const { unit, price, priceExVat, priceCampaign, priceCampaignExVat, quantityPerPallet, quantityPerSquareMeter, unitList } = this.props;
        if (this.state.isBusinessCustomer){
            var currentPrice = this.determinePrice(priceExVat, priceCampaignExVat);
        } else {
            var currentPrice = this.determinePrice(price, priceCampaign);
        }
        let quantity = newQuantity;
        let hiddenQuantity = document.getElementById("calculatedquantity");
        let basequantity = 0;
        if (unit === stUnit) {
            basequantity = parseFloat(quantity);
        } else if (this.isM2Unit(unit)) {
            basequantity = parseFloat(
                quantity / quantityPerSquareMeter
            ).toFixed(4);
        }
        const stSurfaceArea = 1 / quantityPerSquareMeter;
        let totalTemp = parseFloat(basequantity * currentPrice).toFixed(2);
        hiddenQuantity.value = basequantity;
        this.setState({ total: parseFloat(totalTemp).toFixed(2) });
        if (unitList) {
            this.setCorrespondingUnitState(
                quantity,
                stUnit,
                unitList,
                quantityPerPallet,
                quantityPerSquareMeter,
                stSurfaceArea
            );
        }
    }

    calculationsForPallets = (newQuantity) => {
        const { unit, price, priceExVat, priceCampaign, priceCampaignExVat, quantityPerPallet, quantityPerSquareMeter, unitList } = this.props;
        if (this.state.isBusinessCustomer){
            var currentPrice = this.determinePrice(priceExVat, priceCampaignExVat);
        } else {
            var currentPrice = this.determinePrice(price, priceCampaign);
        }
        let quantity = newQuantity;
        let hiddenQuantity = document.getElementById("calculatedquantity");
        let palletQuantity = parseFloat(quantity * quantityPerPallet);
        let tempTotal = palletQuantity * parseFloat(currentPrice).toFixed(2);
        hiddenQuantity.value = palletQuantity;
        this.setState({ total: parseFloat(tempTotal).toFixed(2) });
        if (unitList) {
            this.setCorrespondingUnitState(
                quantity,
                palletUnit,
                unitList,
                quantityPerPallet,
                quantityPerSquareMeter,
                null
            );
        }
    };

    asLocalizedNumber = (value, displayDecimals, unit) => {
        if (unit === palletUnit) {
            return value;
        } else {
            return displayDecimals
            ? parseFloat(value).toFixed(2)
            : Math.round(parseFloat(value)).toString();
        }
    };

    asLocalizedPrice = (value, displayDecimals) => {
        let options = displayDecimals
            ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            : {};
        return parseFloat(Math.ceil(value)).toLocaleString(SwedishCulture, options);
    };

    roundUp = (value) => {
        return Math.ceil(parseFloat(value));
    };

    setCorrespondingUnitState(quantity, currentUnit, changeUnits, quantityPerPallet, quantityPerSquareMeter, stSurfaceArea) {
        quantity = parseFloat(quantity)

        changeUnits && changeUnits.forEach((changeUnit) => {
            changeUnit = changeUnit.toLowerCase();

            if (changeUnit === M2Unit) {
                changeUnit = m2UnitV2;
            }

            if (changeUnit === currentUnit.toLowerCase()) {
                return;
            }

            let convertedValue = 0;

            switch (changeUnit) {
                case M2Unit:
                case m2UnitV2:
                    if (currentUnit === stUnit) {
                        convertedValue = this.asLocalizedNumber(
                            stSurfaceArea * quantity,
                            true
                        );
                    } else if (currentUnit === palletUnit) {
                        if(this.getSelectedUnitValue() === stUnit) {
                            convertedValue = this.asLocalizedNumber(
                                (quantityPerPallet / quantityPerSquareMeter) * quantity,
                                true
                            );
                        } else {
                            convertedValue = this.asLocalizedNumber(
                                quantityPerPallet * quantity,
                                true
                            );
                        }
                    }

                    break;

                case stUnit:
                    if (currentUnit === m2UnitV2) {
                        convertedValue = this.asLocalizedNumber(
                            quantity * quantityPerSquareMeter,
                            false
                        );
                    } 
                    
                    if (currentUnit === palletUnit && this.getSelectedUnitValue() === stUnit) {
                        convertedValue = this.asLocalizedNumber(
                            quantity * quantityPerPallet,
                            false
                        );
                    } else if (currentUnit === palletUnit && this.getSelectedUnitValue() === m2UnitV2) {
                        // convert quantity st to m2 before calculating pallet if default unit is m2
                        convertedValue = this.asLocalizedNumber(
                            quantityPerPallet * quantityPerSquareMeter * quantity,
                            true
                        );
                    }

                    break;

                case palletUnit:
                    let pallets = quantity / quantityPerPallet;
                    if (currentUnit === stUnit && this.getSelectedUnitValue() === m2UnitV2) {
                        // convert quantity st to m2 before calculating pallet if default unit is m2
                        quantity = this.asLocalizedNumber(
                            stSurfaceArea * quantity,
                            true
                        );
                        pallets = quantity / quantityPerPallet;
                    } else if (currentUnit === m2UnitV2 && this.getSelectedUnitValue() === stUnit) {
                        quantity = this.asLocalizedNumber(
                            (quantityPerSquareMeter / quantityPerPallet) * quantity,
                            true
                        );
                        pallets = quantity;
                    }

                    convertedValue = this.setPalletDecimals(pallets)
                    
                    break;
            }

            this.setState(
                (prevState) => ({
                    quantities: {
                        ...prevState.quantities,
                        [changeUnit]: convertedValue,
                    },
                })
            );
    
            const ref = this[`quantityInputElement_${changeUnit}`];
            if (ref) {
                ref.value = this.asLocalizedNumber(convertedValue, this.shouldDisplayWithDecimals(changeUnit), changeUnit);
            }
        })
    }

    setPalletDecimals = (value) => {
        // Returns a string value up to 3 decimals if necessarily otherwise none.
        let string = value.toString().replace(',', '.');
        let number = parseFloat(string);
        string = number.toFixed(3).replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');

        return string;
    };

    calculateWastage = () => {
        const { quantities } = this.state;
        let quantity = parseFloat(quantities[this.getSelectedUnitValue()]);
        let wastagePercent = this.props.wastagePercent;
        let wastageAmount = quantity * wastagePercent * 0.01;

        if (this.isWastageActive()) {
            this.setQuantityBeforeWastage(quantity);

            if (this.shouldDisplayWithDecimals(this.getSelectedUnitValue())) {
                quantity = quantity + wastageAmount;
            } else {
                quantity = this.roundUp(quantity + wastageAmount);
            }
        } else {
            quantity = this.getQuantityBeforeWastage();
        }

        if (quantity > 0) {
            this.setQuantityState(quantity, this.getSelectedUnitValue());
        }
    };

    extractUnitFromElementId = (elementId) => {
        return elementId.split('_')[1];
    };

    toggleCalculator = () => {
        this.setState((prevState) => {
            const isOpen = !prevState.isQuantityCalculatorOpen;
            if (isOpen) {
                this.props.hideBuyButton();
            } else {
                this.props.showBuyButton();
            }
    
            return { isQuantityCalculatorOpen: isOpen };
        });
    
        const clickedButton = document.getElementById("quantityCalculatorButton");
    
        if (clickedButton) {
            clickedButton.classList.toggle("active");
        }
    };

    render() {
        const {
            inputId,
            unit,
            minimumQuantity,
            wholePallet,
            wholePalletMessage,
            unitList,
            quantityPerPallet,
            quantityPerSquareMeter,
            currency,
            isFromProductPage,
            isFromCategoryPage,
            isFromCartMobile,
            hasWastage,
            wastagePercent,
            wastageInfo,
            fogFactor,
            minFogWidth,
            maxFogWidth,
            minTileThickness,
            maxTileThickness,
            sackWeight,
            belowMinFogWidth,
            aboveMaxFogWidth,
            belowMinTileThickness,
            aboveMaxTileThickness,
            showCalculator,
            density,
            calculatorVariants,
            showCompressionCheckbox
        } = this.props;

        this.updateModalButtonText();

        let options = [];
        unitList &&
            unitList.forEach((element) => {
                if (
                    this.isM2Unit(element.toLowerCase())
                ) {
                    let option = {
                        value: m2UnitV2.toLowerCase(),
                        label: translate("product.unitdropdown.m2"),
                    };
                    options.push(option);
                } else if (
                    element.toLowerCase() == palletUnit &&
                    quantityPerPallet > 0
                ) {
                    let option = {
                        value: element.toLowerCase(),
                        label: translate("product.unitdropdown.pallets"),
                    };
                    options.push(option);
                } else if (
                    element.toLowerCase() != m2UnitV2 &&
                    element.toLowerCase() != M2Unit &&
                    element.toLowerCase() != palletUnit
                ) {
                    let option = {
                        value: element.toLowerCase(),
                        label: this.props.useLinearMeter ? translate("linearMeterUnit") : translate("product.unitdropdown.st"),
                    };
                    options.push(option);
                }
            });

        const { quantity, total, unitConversionText, palletInfo } = this.state;
        const localizedMinimumQuantityString = minimumQuantity.toLocaleString(
            i18n.locale
        );
         
        const productPageClass = isFromProductPage ? "row" : "";
        const columnClass = !isFromCategoryPage && !isFromCartMobile ? "small-12 columns" : "";

        return (
            <>
                <div className={productPageClass}>
                    <div className={columnClass}>
                        <div className={productPageClass}>
                            <div className={ isFromProductPage ? "small-6 medium-6 large-4 columns" : "small-12" }>
                                <div className="product-detail__quantity-container">
                                    {wholePallet && !isFromCategoryPage && (
                                        <div className="product-detail__pallet-notification">
                                            {wholePalletMessage}
                                        </div>
                                    )}
                                    {!isFromCategoryPage ? (
                                        options && options.length > 1 ? (
                                            options.map((item, index) => (
                                            <>
                                                <div className="product-detail__quantity-container__input" key={item.label}>
                                                    <div className="product__buy-quantity-container">
                                                        <input disabled={(item.value === stUnit || item.value === m2UnitV2) && this.props.wholePallet}
                                                            id={`${inputId}_${item.value}`}
                                                            type="text"
                                                            defaultValue={this.state.quantities[item.value]}
                                                            onBlur={(event) => this.onQuantityInputElementBlur(event, item.value)}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter') {
                                                                    this.onQuantityInputElementBlur(event, item.value);
                                                                }
                                                            }}
                                                            ref={(element) => (this[`quantityInputElement_${item.value}`] = element)}
                                                            data-buy-quantity-input
                                                            min={localizedMinimumQuantityString}
                                                            step="any"
                                                            maxLength="9"
                                                            lang={i18n.locale}
                                                            className="product-detail__quantity-input form__input"
                                                        />
                                                        <input type="hidden" id="calculatedquantity"></input>
                                                        <label htmlFor={inputId} className="product__unit">
                                                            {item.label}
                                                        </label>
                                                    </div>
                                                    <div className="product__quantity-buttons">
                                                    <button disabled={(item.value === stUnit || item.value === m2UnitV2) && this.props.wholePallet} className="product__quantity-button subtract-btn" onClick={() => this.subtract(item.value)}>
                                                        -
                                                    </button>
                                                    <button disabled={(item.value === stUnit || item.value === m2UnitV2) && this.props.wholePallet} className="product__quantity-button add-btn" onClick={() => this.add(item.value)}>
                                                        +
                                                    </button>
                                                    </div>
                                                </div>
                                                {index !== options.length - 1 && (
                                                    <div className="product-detail__quantity-container__input-divider">
                                                        <p>=</p>
                                                    </div>
                                                )}
                                            </>
                                        ))
                                        ) : (
                                            <>
                                                <div className="product-detail__quantity-container__input">
                                                    <div className="product__buy-quantity-container">
                                                        <input
                                                            id={inputId}
                                                            type="text"
                                                            defaultValue={this.state.quantities[unit]}
                                                            onBlur={(event) => this.onQuantityInputElementBlur(event, unit)}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter') {
                                                                    this.onQuantityInputElementBlur(event, unit);
                                                                }
                                                            }}
                                                            ref={(element) => (this[`quantityInputElement_${unit}`] = element)}
                                                            data-buy-quantity-input
                                                            min={localizedMinimumQuantityString}
                                                            step="any"
                                                            maxLength="9"
                                                            lang={i18n.locale}
                                                            className="product-detail__quantity-input form__input"
                                                        />
                                                        <input type="hidden" id="calculatedquantity"></input>
                                                        <label htmlFor={inputId} className="product__unit">
                                                            {unit}
                                                        </label>
                                                    </div>
                                                    <div className="product__quantity-buttons">
                                                    <button className="product__quantity-button subtract-btn" onClick={() => this.subtract(unit)}>
                                                        -
                                                    </button>
                                                    <button className="product__quantity-button add-btn" onClick={() => this.add(unit)}>
                                                        +
                                                    </button>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    ) : (
                                        <div className="product__card-styling-quantity">
                                            <button className="product__quantity-button subtract-btn" onClick={() => this.subtract(unit)}>
                                                -
                                            </button>
                                            <div className="product__buy-quantity-container">
                                                <input
                                                    id={inputId}
                                                    type="text"
                                                    defaultValue={this.state.quantities[unit]}
                                                    onBlur={(event) => this.onQuantityInputElementBlur(event, unit)}
                                                    onKeyDown={(event) => {
                                                        if (event.key === 'Enter') {
                                                            this.onQuantityInputElementBlur(event, unit);
                                                        }
                                                    }}
                                                    ref={(element) => (this[`quantityInputElement_${unit}`] = element)}
                                                    data-buy-quantity-input
                                                    min={localizedMinimumQuantityString}
                                                    step="any"
                                                    maxLength="9"
                                                    lang={i18n.locale}
                                                    className="product-detail__quantity-input form__input"
                                                />
                                                <input type="hidden" id="calculatedquantity"></input>
                                                {!isFromProductPage ||
                                                options.length == 0 ? (
                                                    <label htmlFor={inputId} className="product__unit">
                                                        {unit}
                                                    </label>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <button className="product__quantity-button add-btn" onClick={() => this.add(unit)}>
                                                +
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {isFromProductPage && (
                        <>
                            {quantityPerPallet > 0 && (
                                <div className="small-12 columns palletInfo">
                                    <PopupModal
                                        model={palletInfo}
                                        withIcon={false}
                                    ></PopupModal>
                                </div>
                            )}
                        </>
                    )}

                    {hasWastage && isFromProductPage && (
                        <div className="small-12 columns wastage-info-wrap">
                            <div className="wastage-info-popup-area ">
                                <input disabled={wholePallet}
                                    id="chkWastage"
                                    type="checkbox"
                                    value={wastagePercent}
                                    onChange={() => this.calculateWastage()}/>
                                <label htmlFor="chkWastage" className="lbl_chkwastage">
                                    {wastageInfo.title}
                                </label>
                                <PopupModal
                                    model={wastageInfo}
                                    withIcon={false}
                                ></PopupModal>
                            </div>
                        </div>
                    )}
                    
                    {!isNaN(fogFactor) && fogFactor > 0 &&(
                        <div className="small-12 columns">
                            <FogsandCalculator 
                                fogFactor={fogFactor} 
                                setQuantityState={this.handleCalculation}
                                minFogWidth={minFogWidth}
                                maxFogWidth={maxFogWidth}
                                minTileThickness={minTileThickness}
                                maxTileThickness={maxTileThickness}
                                sackWeight={sackWeight}
                                belowMinFogWidth={belowMinFogWidth}
                                aboveMaxFogWidth={aboveMaxFogWidth}
                                belowMinTileThickness={belowMinTileThickness}
                                aboveMaxTileThickness={aboveMaxTileThickness}
                            ></FogsandCalculator>
                        </div>
                    )}

                    {showCalculator == "True" && (
                        <div className="small-12 columns">
                            <h4 className="quantity-calculator__border" id="quantityCalculatorButton" onClick={() => this.toggleCalculator()}>{translate("quantityCalculatorOpen")}</h4>
                            {this.state.isQuantityCalculatorOpen && (
                                <>
                                    <QuantityCalculator
                                        density={density}
                                        calculatorVariants={calculatorVariants}
                                        showCompressionCheckbox={showCompressionCheckbox}
                                    ></QuantityCalculator>
                                    <div className="quantity-calculator__product-text" dangerouslySetInnerHTML={{__html: translate("quantityCalculatorProductPageText")}}></div>
                                </>
                            )}
                        </div>
                    )}

                    {isFromProductPage && total > 0 && !this.state.isQuantityCalculatorOpen && (
                        <div className="small-12 columns totaldiv">
                            <span className="primary-unit">
                                <div>{translate("productpage.totalprice")}{" "}</div>
                                <div>
                                    {this.asLocalizedPrice(total, false)}{" "}
                                    {currency}
                                </div>
                            </span>
                        </div>
                    )}
                </div>
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    enableBuyButton,
    disableBuyButton,
    showBuyButton,
    hideBuyButton
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductQuantity);
